// ApiHelper —— 前端唯一的后端出入口。token 存取、错误抛出都收在这里，
// 页面里不要出现裸 fetch。

const TOKEN_KEY = 'hip.token';

export class ApiHelper {
  static token(): string {
    return localStorage.getItem(TOKEN_KEY) || '';
  }

  static setToken(t: string): void {
    if (t) localStorage.setItem(TOKEN_KEY, t);
    else localStorage.removeItem(TOKEN_KEY);
  }

  static async call<T>(path: string, method: string = 'GET', body?: unknown): Promise<T> {
    const headers: Record<string, string> = { 'Content-Type': 'application/json' };
    const t = this.token();
    if (t) headers.Authorization = `Bearer ${t}`;
    const r = await fetch(path, { method, headers, body: body === undefined ? undefined : JSON.stringify(body) });
    const j = await r.json().catch(() => ({ ok: false, msg: `HTTP ${r.status}` }));
    if (!r.ok || j.ok === false) throw new Error(j.msg || `HTTP ${r.status}`);
    return j as T;
  }

  /** 传文件（multipart）。不要自己设 Content-Type，交给浏览器带 boundary。 */
  static async upload<T>(path: string, form: FormData): Promise<T> {
    const headers: Record<string, string> = {};
    const t = this.token();
    if (t) headers.Authorization = `Bearer ${t}`;
    const r = await fetch(path, { method: 'POST', headers, body: form });
    const j = await r.json().catch(() => ({ ok: false, msg: `HTTP ${r.status}` }));
    if (!r.ok || j.ok === false) throw new Error(j.msg || `HTTP ${r.status}`);
    return j as T;
  }

  /**
   * 取二进制并包成 File，交给上传流程当成"用户刚选的文件"用。
   * 示例 BOM 的一键试算靠它：同一份文件既能下载、也能直接送去估价，两条路走同一个后端接口。
   */
  static async fetchFile(path: string, fileName: string): Promise<File> {
    const headers: Record<string, string> = {};
    const t = this.token();
    if (t) headers.Authorization = `Bearer ${t}`;
    const r = await fetch(path, { headers });
    if (!r.ok) throw new Error(`HTTP ${r.status}`);
    const blob = await r.blob();
    return new File([blob], fileName, { type: blob.type });
  }

  /** 取二进制并触发浏览器下载 */
  static async download(path: string, body: unknown, fileName: string): Promise<void> {
    const headers: Record<string, string> = { 'Content-Type': 'application/json' };
    const t = this.token();
    if (t) headers.Authorization = `Bearer ${t}`;
    const r = await fetch(path, { method: 'POST', headers, body: JSON.stringify(body) });
    if (!r.ok) {
      const j = await r.json().catch(() => ({ msg: `HTTP ${r.status}` }));
      throw new Error(j.msg || `HTTP ${r.status}`);
    }
    const blob = await r.blob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  }
}
